// Bank holiday dates travel as "yyyy-MM-dd" and are shown as dd/MM/yyyy.
// Built from the date's own parts, never toISOString(), which would shift a UK
// midnight back a day in summer time.

function pad(n) {
  return n < 10 ? '0' + n : '' + n
}

export function toIsoDate(date) {
  if (!(date instanceof Date) || isNaN(date.getTime())) return null
  return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate())
}

export function fromIsoDate(iso) {
  var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || '')
  return m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : null
}

export function displayDate(iso) {
  var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || '')
  return m ? m[3] + '/' + m[2] + '/' + m[1] : (iso || '')
}
